// //Get web worker instance
let initial = new Worker(process.env.PUBLIC_URL + '/serialWorker.js', {
    type: 'module',
})

const workerReducer = (state = initial) => {
    return state
}
export default workerReducer
